import { Grid, SelectChangeEvent } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useState } from 'react'
import {
  BasicButton,
  ContentWrapper,
  Select,
  TitledSection
} from '../../../../components'
import { useLocalizedPaymentOptions } from '../../../../hooks'
import { isArrayWithLength } from '../../../../utils'
import { usePaymentInfo } from '../contexts'

const useStyles = makeStyles(() => ({
  paymentSection: {
    marginTop: '0rem',
    marginLeft: '0'
  },
  bankSelect: {
    width: '100%'
  }
}))

export const MembershipFeePaymentOptions = () => {
  const localizedPaymentOptions = useLocalizedPaymentOptions()
  const classes = useStyles()

  const [url, setUrl] = useState('')
  const { paymentInfo } = usePaymentInfo()
  if (!paymentInfo) {
    return null
  }

  const handleChange = (e: SelectChangeEvent) => {
    const targetUrl = e.target.value
    setUrl(targetUrl)
  }

  const handleClick = () => {
    const content = paymentInfo.virtualBarCode

    navigator.clipboard.writeText(content)

    setTimeout(async () => await window.open(url), 300)
  }

  return (
    <TitledSection translationid="pages.membershipFeesPage.calculateMembershipFeePage.paymentTitle">
      <Grid
        container
        alignItems="flex-end"
        className={classes.paymentSection}
        rowSpacing={2}
      >
        <ContentWrapper
          showContent={isArrayWithLength(localizedPaymentOptions)}
        >
          <Select
            name="paymentOption"
            executeOnChangeFn={handleChange}
            gridProps={{ md: 4 }}
            labelTranslationId="pages.membershipFeesPage.calculateMembershipFeePage.bank"
            options={localizedPaymentOptions}
            value={url}
            variant="standard"
          />
          <Grid item>
            <BasicButton
              onClick={handleClick}
              translationId="pages.membershipFeesPage.calculateMembershipFeePage.toPayment"
              sx={{ ml: 2 }}
            />
          </Grid>
        </ContentWrapper>
      </Grid>
    </TitledSection>
  )
}
